import firebase from "firebase/compat/app"
import { useSelector } from "../../modules/store/customSelector"

export const useAuth = (): firebase.User | undefined => useSelector((state) => state.userData.user)

export const useGetSmsUserId = (): string | undefined => useSelector(state => state.userData.smsAuth.userId)
export const useGetSmsPhoneNumber = (): string | undefined => useSelector(state => state.userData.smsAuth.phoneNumber)
